import { RootState } from "../../../../redux/store";
import { useSelector } from "react-redux";
import React from "react";
import { cn } from "../../../../helpers/cn";

type ListingModalWrapperProps = React.ComponentProps<"div">;

export const ListingModalWrapper = ({
  className,
  children,
}: ListingModalWrapperProps) => {
  const colors = useSelector((state: RootState) => state.theme.componentColors);

  return (
    <div
      className={cn(
        "rounded-[1.75rem] flex items-center justify-center " +
          "md:mx-auto md:max-w-[344px] lg:max-w-[none] p-4 lg:p-6",
        className,
      )}
      style={{
        backgroundColor: colors.surface.surfContainerHigh,
      }}
    >
      {children}
    </div>
  );
};
